import { useMemo } from "react";
import { IExtendedSearchData } from "src/api/server/extended-search.types";
import { MobileSearchFilterContainer } from "src/components/pages/search/components/filter-section/mobile-search-filter/mobile-search-filter-container";
import { SearchFilterContainer } from "src/components/pages/search/components/filter-section/search-filter/search-filter-container";
import { setDefaultFilters, setQuery } from "src/components/pages/search/store/actions";
import { useSearchStore } from "src/components/pages/search/store/search-store";
import { getNextAvailableRanking } from "src/components/pages/search/utils/get-next-available-ranking";
import { getPopularFilters } from "src/components/pages/search/utils/get-popular-filters";
import { removeSearchTermFromUrl } from "src/components/pages/search/utils/remove-search-term-from-url";
import { getRouterLocale } from "src/utils/router/use-router-locale";
import { sanitizeSearchTerm } from "src/utils/sanitize-search-term";

interface IFilterSectionProps {
    data: IExtendedSearchData;
    resultCount: number | null;
    isLoading: boolean;
    onReset: () => void;
}

export const FilterSection = ({ data, resultCount, isLoading, onReset }: IFilterSectionProps) => {
    const { query, selectedFigures } = useSearchStore();
    const sanitizedSearchTerm = query ? sanitizeSearchTerm(query) : undefined;

    const { tagsData, keyFiguresData } = data;
    const { popularKeyFiguresGroup, keyFiguresGroupsWithIsPopularIndication, popularTags, keyFiguresDataWithPopularIndication } = useMemo(() => {
        const popularFilters = getPopularFilters(tagsData, keyFiguresData);
        return {
            ...popularFilters,
            keyFiguresDataWithPopularIndication: { ...keyFiguresData, keyFiguresGroups: popularFilters.keyFiguresGroupsWithIsPopularIndication },
        };
    }, [tagsData, keyFiguresData]);

    const handleOnSearchTermClear = () => {
        const remainingQuery = removeSearchTermFromUrl();
        const {
            rankingsData: { rankings, relevanceRanking },
        } = data;

        if (!remainingQuery.sortBy) {
            const availableRanking = getNextAvailableRanking({ rankings, relevanceRanking, selectedFigures });
            setDefaultFilters({ id: availableRanking.id, sortDirection: availableRanking.sortDirection }, getRouterLocale().country);
        }
        setQuery("");
    };

    return (
        <>
            <MobileSearchFilterContainer
                searchTerm={sanitizedSearchTerm}
                resultCount={resultCount}
                isLoading={isLoading}
                tagsData={tagsData}
                popularKeyFiguresGroup={popularKeyFiguresGroup}
                keyFiguresGroupsWithIsPopularIndication={keyFiguresGroupsWithIsPopularIndication}
                popularTags={popularTags}
                onSearchTermClear={handleOnSearchTermClear}
                onReset={onReset}
            />
            <SearchFilterContainer
                searchTerm={sanitizedSearchTerm}
                resultCount={resultCount}
                popularKeyFiguresGroup={popularKeyFiguresGroup}
                popularTags={popularTags}
                keyFiguresData={keyFiguresDataWithPopularIndication}
                tagsData={tagsData}
                onSearchTermClear={handleOnSearchTermClear}
                onReset={onReset}
            />
        </>
    );
};
